//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mixin from './mixin'
export default {
    mixins: [
        mixin
    ],
    data () {
        return {
            result: {
                all_taxes: '',
                all_price: '',
                unit_price: '',
                area: '',
                detail: []
            }
        }
    },
    mounted () {
        const { params } = this.$route.query
        if (params) {
            this.result = JSON.parse(params)
        } else {
            wx.redirectTo({
                url: '/packageA/taxes_calculate/main'
            })
        }
    },
}
